import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import regeneratorRuntime from "/home/runner/work/cloud-services/cloud-services/node_modules/.pnpm/next@12.2.5_bw5me6qlxrwkidqrhljke6qy5u/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return _instanceof(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useEffect, useState } from "react";
export var VersionContext = /*#__PURE__*/ createContext({
    commit: null,
    version: null
});
var VersionContextWrapper = function(param) {
    var children = param.children;
    var ref = useState(null), version = ref[0], setVersion = ref[1];
    var ref1 = useState(null), commit = ref1[0], setCommit = ref1[1];
    useEffect(function() {
        if (version && commit) {
            return;
        }
        (function() {
            return __awaiter(void 0, void 0, void 0, regeneratorRuntime.mark(function _callee() {
                var response, ref, version, commit;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return fetch("/version");
                        case 2:
                            response = _ctx.sent;
                            if (!(response.status !== 200)) {
                                _ctx.next = 5;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 5:
                            _ctx.prev = 5;
                            _ctx.next = 8;
                            return response.json();
                        case 8:
                            ref = _ctx.sent;
                            version = ref.version;
                            commit = ref.commit;
                            setVersion(version);
                            setCommit(commit);
                            _ctx.next = 17;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](5);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        5,
                        15
                    ]
                ]);
            }));
        })();
    }, []);
    return /*#__PURE__*/ React.createElement(VersionContext.Provider, {
        value: {
            commit: commit,
            version: version
        }
    }, children);
};
export default VersionContextWrapper;
